import React from 'react'

import { Box } from '@mui/material'

import DatePicker from 'components/input/DatePicker'

type CustomerMetricsDatePickerProps = {
  dates: { end: string; start: string }
  setDates: (...args: any[]) => any
}

const CustomerMetricsDatePicker = ({ dates, setDates }: CustomerMetricsDatePickerProps) => {
  const handleDateChange = type => value => setDates(dates => ({ ...dates, [type]: value }))

  // input-decorated DatePicker: the HOC's typed props don't match this usage — cast (loose).
  const AnyDatePicker = DatePicker as any

  return (
    <Box sx={{ display: 'flex', '& > div': { ml: '1rem' } }}>
      <AnyDatePicker label="Start" onChange={handleDateChange('start')} value={dates.start} />
      <AnyDatePicker label="End" onChange={handleDateChange('end')} value={dates.end} />
    </Box>
  )
}

export default CustomerMetricsDatePicker
